(() => {
  'use strict';
  // PATAGONIA — parcours d'achat, 28-10.
  // 1. Panier et tiroir, mobile et desktop : afficher le vrai montant de livraison
  //    au lieu de « à calculer ». Le moteur du thème ne sait pas chiffrer un panier
  //    qui mélange Sélection et spécialité, alors que les deux partagent le même
  //    profil d'expédition Shopify. On chiffre donc sur le poids réel du panier.
  // 2. Nos cafés, mobile seulement : le Pack Découverte avant le catalogue,
  //    pour un visiteur qui n'a pas encore commandé.
  // 3. Avis : note moyenne vérifiée juste avant le bouton de paiement (masquée en desktop par la CSS).
  const mobile = window.matchMedia('(max-width: 749px)');
  const NBSP = String.fromCharCode(160);

  // Grille réelle des profils d'expédition Shopify, en centimes et en grammes de colis.
  const RELAY = w => (w <= 1250 ? 290 : 0);
  const HOME = w => (w <= 1250 ? 500 : (w <= 1800 ? 290 : 0));
  const euros = c => (c === 0 ? 'Offerte' : (c / 100).toFixed(2).replace('.', ',') + ' €');
  const clean = s => String(s || '').split(NBSP).join(' ').trim().toLowerCase();

  // Client déjà venu ? Le drapeau Liquid d'abord, puis la trace locale.
  function known() {
    try {
      const tag = document.getElementById('pcm27-client');
      if (tag && JSON.parse(tag.textContent).known === true) return true;
      return localStorage.getItem('pcm27-client') === '1';
    } catch (e) { return false; }
  }

  function classify(cart) {
    let pack = false, sub = false, coffee = false;
    (cart.items || []).forEach(i => {
      const h = i.handle || '';
      if (h === 'pack-decouverte') pack = true;
      else if (h === 'abonnement-cafe' || i.selling_plan_allocation) sub = true;
      else coffee = true;
    });
    if (sub) return 'abonnement';
    if (pack && coffee) return 'mixte';
    if (pack) return 'pack';
    if (coffee) return 'cafes';
    return 'vide';
  }

  function checkoutButton(root) {
    return [...root.querySelectorAll('button, a, input[type=submit]')]
      .find(e => /passer au paiement/i.test(e.textContent || e.value || ''));
  }
  function leaves(root) {
    return [...root.querySelectorAll('*')].filter(e => e.children.length === 0);
  }
  function setText(e, v) { e.textContent = v; e.classList.add('pcp28-done'); }

  function setValue(label, value) {
    if (!label || !value) return;
    const t = leaves(label).filter(e => clean(e.textContent) === 'à calculer').pop();
    if (t) setText(t, value);
  }

  // Le panier se redessine tout seul : on garde le nœud d'avis sous la main
  // pour le replacer après chaque redessin au lieu de le perdre.
  let proofNode = null;

  async function priceCart() {
    const host = document.querySelector('[data-pcf-cart]');
    if (!host) return;
    if (!proofNode) proofNode = document.querySelector('.pcp28-proof--cart');
    let cart;
    try { cart = await (await fetch('/cart.js', { credentials: 'same-origin' })).json(); } catch (e) { return; }
    if (!cart || !cart.item_count) return;
    const kind = classify(cart);
    const weight = cart.total_weight || 0;
    const labels = [...host.querySelectorAll('label, li, .pcf-choice')];
    const relay = labels.find(e => /point relais/i.test(e.textContent));
    const home = labels.find(e => /domicile/i.test(e.textContent));
    let relayTxt = null, homeTxt = null, note = '';

    if (kind === 'cafes') {
      relayTxt = euros(RELAY(weight));
      homeTxt = euros(HOME(weight));
      note = 'Calculé sur le poids de votre panier, ' +
        (weight / 1000).toFixed(2).replace('.', ',') + ' kg. Montant confirmé au paiement.';
    } else if (kind === 'pack') {
      relayTxt = 'Offerte'; homeTxt = 'Offerte';
      note = 'Livraison offerte avec le Pack Découverte.';
    } else if (kind === 'mixte') {
      relayTxt = 'Offerte'; homeTxt = 'Offerte';
      note = 'Livraison offerte sur toute la commande grâce au Pack Découverte.';
    } else if (kind === 'abonnement') {
      note = 'Livraison de l’abonnement précisée au paiement.';
    }
    setValue(relay, relayTxt);
    setValue(home, homeTxt);

    if (relayTxt) {
      const chosen = (home && home.querySelector('input:checked')) ? homeTxt : relayTxt;
      leaves(host).forEach(e => {
        const t = clean(e.textContent);
        if (t === 'à calculer') { setText(e, chosen); return; }
        if (t.indexOf('hors livraison') !== -1) {
          e.textContent = e.textContent.replace(/ *hors livraison/i, '');
          return;
        }
        if (t.indexOf('frais seront précisés') !== -1) { e.hidden = true; }
      });
    }

    // Le total et le bouton peuvent avoir été regroupés dans un socle collant :
    // la note et les avis se posent avant ce socle, pas dedans.
    const btn = checkoutButton(host);
    const anchor = btn ? (btn.closest('.pcp28-dock') || btn) : null;
    if (note) {
      let p = host.querySelector('.pcp28-note');
      if (!p) { p = document.createElement('p'); p.className = 'pcp28-note'; }
      p.textContent = note;
      if (anchor && anchor.parentElement) anchor.parentElement.insertBefore(p, anchor);
      else if (!p.parentElement) host.append(p);
    }
    if (proofNode) {
      // Un seul bloc d'avis, quoi qu'il arrive : on écarte les doublons éventuels.
      document.querySelectorAll('.pcp28-proof--cart').forEach(n => { if (n !== proofNode) n.remove(); });
    }
    if (proofNode && anchor && anchor.parentElement) {
      if (proofNode.nextElementSibling !== anchor || proofNode.parentElement !== anchor.parentElement) {
        anchor.parentElement.insertBefore(proofNode, anchor);
      }
      proofNode.hidden = false;
    }
  }

  function watchCart() {
    const host = document.querySelector('[data-pcf-cart]');
    if (!host || host.dataset.pcpWatched === '1') return;
    host.dataset.pcpWatched = '1';
    priceCart();
    let timer;
    const again = () => { clearTimeout(timer); timer = setTimeout(priceCart, 300); };
    new MutationObserver(again).observe(host, { childList: true, subtree: true });
    host.addEventListener('change', again);
  }

  const movedPack = new Map();
  function applyMobile() {
    // Un habitué n'a pas besoin du Pack en premier : il vient chercher ses sachets.
    if (!mobile.matches || known()) {
      movedPack.forEach((marker, node) => marker.replaceWith(node));
      movedPack.clear();
      return;
    }
    const sections = [...document.querySelectorAll('#MainContent .shopify-section')];
    const pack = sections.find(s => s.querySelector('.pc-discovery'));
    const cat = sections.find(s => s.querySelector('.pc4-grid'));
    if (pack && cat && !movedPack.has(pack) &&
        (pack.compareDocumentPosition(cat) & Node.DOCUMENT_POSITION_PRECEDING)) {
      const marker = document.createComment('pcp28-pack');
      pack.before(marker);
      cat.before(pack);
      movedPack.set(pack, marker);
    }
  }

  function init() { applyMobile(); watchCart(); }
  mobile.addEventListener('change', () => { applyMobile(); priceCart(); });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();